import { headerData } from "./headerData"

export const aboutData = {
    title: 'About',
    description1: 'I’m ' + headerData.name + ', a Full Stack Developer with 9+ years of experience.',
    description2: 'I build scalable systems, modernize legacy apps, and deliver secure cloud-based solutions.',
    highlights: ['Modernization', 'Microservices', 'Secure APIs', 'Cloud & DevOps'],
    image: 1
}